import { DATASET, ROUTER_DATASET } from '@wix/wix-data-client-common'
import * as panelDefs from '@wix/wix-data-client-common/dist/esm/panels/panelDefs'
import getPanelUrl from '@wix/wix-data-client-common/dist/esm/panels/getPanelUrl'
import { isSinglesCollectionSchema } from '@wix/wix-data-client-common/dist/esm/collections/collectionTypes'

import {
  PANEL_DIMENSIONS_FOR_MULTI_COLLECTION,
  PANEL_DIMENSIONS_FOR_SINGLES_COLLECTION,
} from './consts'

const getControllerTitle = ({ controllerType }) => {
  switch (controllerType) {
    case ROUTER_DATASET:
      return 'DYNAMIC_PAGES_DATASET_PANEL_TITLE'
    case DATASET:
      return 'DATASET_SETTINGS_PANEL_TITLE'
  }
}

export default async (
  { hostname, collectionsApi, editorSdkProxy, appApi, i18n },
  {
    controllerRef,
    controllerConfig,
    controllerDisplayName,
    controllerType,
    editorType,
  },
) => {
  const initialLoadTimeForBI = Date.now()

  const oldDatasetConfig = await appApi.fetchDataset(controllerRef)
  const collectionId = oldDatasetConfig?.config?.collectionId
  const isSinglesCollection =
    collectionId &&
    isSinglesCollectionSchema(
      await collectionsApi.get(collectionId).catch(() => ({})),
    )

  const panelDimensions = isSinglesCollection
    ? PANEL_DIMENSIONS_FOR_SINGLES_COLLECTION
    : PANEL_DIMENSIONS_FOR_MULTI_COLLECTION

  await editorSdkProxy.editor.openComponentPanel({
    componentRef: controllerRef,
    title: i18n.t(
      getControllerTitle({
        controllerType,
      }),
    ),
    url: await getPanelUrl({
      hostname,
      relativeUrl: panelDefs.datasetConfig.url,
      editorSdkProxy,
    }),
    initialData: {
      controllerRef,
      controllerConfig,
      controllerDisplayName,
      controllerType,
      initialLoadTimeForBI,
      editorType,
    },
    ...panelDimensions,
    helpId:
      controllerType === ROUTER_DATASET
        ? 'c614e1b9-bc1b-409d-942f-0e865ecf3b74'
        : 'dcfadf7a-aec9-4f02-9c42-0e22397daae0',
  })
}
